import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import ArrowRight from "../../../assets/icon/arrow-right-purple.svg";
import PatientsDemographic from "components/PatientsDemographic";
import HoverImage from "react-hover-image/build";
import drugPurpleIcon from "../../../assets/icon/drug-status.svg";
import drugLightIcon from "../../../assets/icon/drug-with-reddot.svg";
import drugList from "../../../assets/icon/drug-list.svg";
import drugWhite from "../../../assets/icon/druglist-green.svg";
import closeIcon from "../../../assets/icon/close-icon.svg";
import threeDotsIcon from "../../../assets/icon/3-dots.svg";
import plusIcon from "../../../assets/icon/plus-icon-add-note.svg";
import uploadIcon from "../../../assets/icon/upload-icon.svg";
import PrescriptionSummary from "components/PrescriptionSummary";
import Drawer from "components/Drawer";
import DrugUtilPopUp from "pages/OrderEntry/DrugUtilPopUp";
import ClaimsInfo from "pages/OrderEntry/ClaimsInfo";
import { useLocation, useNavigate } from "react-router-dom";
import InitialPatientEditDetails from "../InitialPatientEditDetails";
import MessageIconDark from "../../../assets/icon/messageIcon-dark.svg";
import MessageIconLight from "../../../assets/icon/messageIcon-light.svg";
import completeIcon from "../../../assets/icon/complete.svg";
import leftArrow from "../../../assets/icon/left-arrow.svg";
import CloseIcon from "../../../assets/icon/chatClose.svg";
import editIcon from "../../../assets/icon/edit-black-icon.svg";
import appoveIcon from "../../../assets/icon/approve-icon.svg";
import profileIcon from "../../../assets/icon/profile-icon.svg";
import orderDetailsIcon from "../../../assets/icon/order-details-icon.svg";
import patientProfile from "../../../assets/icon/patient-profile.svg";
import rxHistory from "../../../assets/icon/rx-history-icon.svg";
import purpleCrossIcon from "../../../assets/icon/purple-cross-icon.svg";
import statusPurple from "../../../assets/icon/status-save-icon.svg";
import { toast } from "react-toastify";
import Chating from "pages/OrderEntry/Chating";
import sendBackIcon from "assets/icon/send-back-btn.svg";
import editPurple from "assets/icon/edit-purple.svg";

const InitialReviewPatientDetails = () => {
  const [drugUtil, setDrugUtil] = useState(false);
  const [claimsInfo, setClaimsInfo] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [openPatinetsDetails, setOpenPatinetsDetails] = useState("10");
  const [endDate, setEndDate] = useState(null);
  const [startDate, setStartdate] = useState(null);
  const [focusedInput, setFocusedInput] = useState("");
  const [openOne, setOpenOne] = useState("1");
  const [openTwo, setOpenTwo] = useState("1");
  const [openThree, setOpenThree] = useState("1");
  const [searchTerm, setSearchTerm] = useState("");
  const [scale, setScale] = useState(1);
  const [msgInfo, setMsgInfo] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);

  // const initialImage = patientsScanImage;
  // const [image, setImage] = useState(initialImage);
  const [patientEditDetails, setPatientEditDetails] = useState(false);
  const navigate = useNavigate();
  const currentStep = 3;
  const handleClickStatus = () => {
    setOpenStatus((prevState) => !prevState);
  };
  const namesData = {
    fullName: "John Doe",
    firstName: "John",
    lastName: "Doe",
    phone: "(555) 123-4567",
    dob: "01/08/1996 (28 Years)",
  };
  const numSteps = 9;

  const location = useLocation();
  const rowData = location.state;

  console.log(rowData, 3333);

  const patientDetails = [
    {
      name: rowData.patient,
      dob: "01/08/1996",
      phone: "(555) 123-4567",
      prescriberName: "Smith, Robert",
      officeAddess: "1234cMaple Rd,Anytown,USA",
      officePhone: "(555) 123-4567",
      medication: "Venlafaxine ER Tablet 150MG",
      daw: "0-Not specified",
      quantity: "30 EA",
      direction: "Take 1 tablet by mouth",
      refills: "05",
      dateWritten: "12/19/2024",
      notes: "Please contact the office to report any insurance issues",
      signature: "Robert Smith.MD at 12/19/2024, 1:02 PM EST",
    },
  ];

  const togglePatientDetails = (id) => {
    if (openPatinetsDetails === id) {
      setOpenPatinetsDetails();
    } else {
      setOpenPatinetsDetails(id);
    }
  };

  const onApprove = () => {
    toast.success("E-Prescription has successfully approved");
  };

  const handleBack = () => {
    navigate(-1);
  };

  const togglebtnOne = (id) => {
    if (openOne === id) {
      setOpenOne();
    } else {
      setOpenOne(id);
    }
  };

  const togglebtnTwo = (id) => {
    if (openTwo === id) {
      setOpenTwo();
    } else {
      setOpenTwo(id);
    }
  };
  const togglebtnThree = (id) => {
    if (openThree === id) {
      setOpenThree();
    } else {
      setOpenThree(id);
    }
  };

  return (
    <>
      <Container fluid className="details-page-body  bg-white p-3">
        <Container
          fluid
          className="d-flex gap-2 justify-content-between orderEntry-heading section-devider-border mb-8"
        >
          <div className="heading-text d-flex gap-2">
            <img
              src={leftArrow}
              className="cursor-pointer left-arrow-btn"
              onClick={handleBack}
            />
            Order Details (Rx-1029484)
          </div>
          <div
            className="d-flex justify-content-end"
            style={{ fontSize: "16px" }}
          >
            <div onClick={handleClickStatus} className="status-hover">
              {openStatus ? (
                <img src={purpleCrossIcon} alt="icon" />
              ) : (
                <img src={statusPurple} alt="icon" />
              )}{" "}
              <span style={{ marginLeft: "8px" }}>Order Status</span>
            </div>
          </div>
        </Container>
        <Container fluid>
          {openStatus && (
            <div className="popup-status-partent">
              <div className="popup-status">
                <div className="stepper-horizontal " id="stepper1">
                  {Array.from({ length: numSteps }, (_, index) => {
                    const stepNum = index + 1;
                    return (
                      <div
                        className={`step 
                                          ${
                                            stepNum === currentStep
                                              ? "editing fffff"
                                              : ""
                                          }
                                           ${
                                             stepNum < currentStep ? "done" : ""
                                           }`}
                        key={stepNum}
                      >
                        <div className="step-circle">
                          <span>{stepNum}</span>
                        </div>
                        <div>
                          {stepNum === 1 ? (
                            <>
                              <div className="step-title">Patient </div>
                              <div className="step-desc">
                                <div className="step-time">13:21, </div>
                                <div className="step-time">
                                  {" "}
                                  02/06/2025
                                </div>{" "}
                              </div>
                            </>
                          ) : stepNum === 2 ? (
                            <>
                              <div className="step-title">E-Rx </div>
                              <div className="step-desc">
                                <div className="step-time">13:21, </div>
                                <div className="step-time">
                                  {" "}
                                  02/06/2025
                                </div>{" "}
                              </div>
                            </>
                          ) : stepNum === 3 ? (
                            <>
                              <div className="step-title">Order Entry </div>
                              <div className="step-desc">
                                <div className="step-time">13:21, </div>
                                <div className="step-time">
                                  {" "}
                                  02/06/2025
                                </div>{" "}
                              </div>
                            </>
                          ) : stepNum === 4 ? (
                            <>
                              <div className="step-title">Dur </div>
                              <div className="step-desc">
                                <div className="step-time">13:21, </div>
                                <div className="step-time">
                                  {" "}
                                  02/06/2025
                                </div>{" "}
                              </div>
                            </>
                          ) : stepNum === 5 ? (
                            <>
                              <div className="step-title">Claim Details </div>
                              <div className="step-desc">
                                <div className="step-time">13:21, </div>
                                <div className="step-time">
                                  {" "}
                                  02/06/2025
                                </div>{" "}
                              </div>
                            </>
                          ) : stepNum === 6 ? (
                            <>
                              <div className="step-title">Initial Review </div>
                              <div className="step-desc">
                                <div className="step-time">13:21, </div>
                                <div className="step-time">
                                  {" "}
                                  02/06/2025
                                </div>{" "}
                              </div>
                            </>
                          ) : stepNum === 7 ? (
                            <>
                              <div className="step-title">Packaging </div>
                              <div className="step-desc">
                                <div className="step-time">13:21, </div>
                                <div className="step-time">
                                  {" "}
                                  02/06/2025
                                </div>{" "}
                              </div>
                            </>
                          ) : stepNum === 8 ? (
                            <>
                              <div className="step-title">Final Review </div>
                              <div className="step-desc">
                                <div className="step-time">13:21, </div>
                                <div className="step-time">
                                  {" "}
                                  02/06/2025
                                </div>{" "}
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="step-title">Sales </div>
                              <div className="step-desc">
                                <div className="step-time">13:21, </div>
                                <div className="step-time">
                                  {" "}
                                  02/06/2025
                                </div>{" "}
                              </div>
                            </>
                          )}
                        </div>

                        {/* Only show content for the active step */}

                        <div className="step-bar-left"></div>
                        <div className="step-bar-right"></div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </Container>
        <Container fluid>
          <PatientsDemographic
            fullName={rowData.patient}
            firstName={rowData.patient.split(",")[0].trim()}
            lastName={rowData.patient.split(" ")[1]?.trim()}
            dob={namesData.dob}
            phone={namesData.phone}
          />
          <Container />
          <div className="logo-drawer">
            <Row>
              <Col className="d-flex justify-content-start gap-2">
                <div
                  // className="drug-status"
                  onClick={() => setDrugUtil(!drugUtil)}
                  id="ScheduleUpdateTooltip"
                >
                  <HoverImage
                    className="drug-status"
                    src={drugPurpleIcon}
                    hoverSrc={drugLightIcon}
                    alt=""
                  />
                  <UncontrolledTooltip
                    placement="bottom"
                    target="ScheduleUpdateTooltip"
                    trigger="hover"
                  >
                    Drug Utilization Review
                  </UncontrolledTooltip>
                </div>
                <div
                  // className="drug-status"
                  onClick={() => setClaimsInfo(!claimsInfo)}
                  id="ScheduleUpdateTooltip2"
                >
                  <HoverImage
                    src={drugList}
                    className="drug-status"
                    hoverSrc={drugWhite}
                    alt=""
                  />
                  <UncontrolledTooltip
                    // className="tooltip-custom"
                    style={{ position: "relative", left: "30px" }}
                    placement="bottom"
                    target="ScheduleUpdateTooltip2"
                    trigger="hover"
                  >
                    Claims Information
                  </UncontrolledTooltip>
                </div>
                <div
                  // className="drug-status"
                  onClick={() => setMsgInfo(!msgInfo)}
                  id="ScheduleUpdateTooltip3"
                >
                  <HoverImage
                    src={MessageIconDark}
                    className="drug-status"
                    hoverSrc={MessageIconLight}
                    alt=""
                  />
                  <UncontrolledTooltip
                    // className="tooltip-custom"
                    style={{ position: "relative", left: "30px" }}
                    placement="bottom"
                    target="ScheduleUpdateTooltip3"
                    trigger="hover"
                  >
                    Comments
                  </UncontrolledTooltip>
                </div>
                <div className="comment">
                  <img src={completeIcon} alt="not available" />
                  340B Eligible
                </div>
              </Col>
              <Col className="d-flex justify-content-end">
                <Button color="primary" className="reset">
                  <img src={patientProfile} />
                  Patient Profile
                </Button>
                <Button className="back-button primary">
                  {" "}
                  <img src={rxHistory} />
                  Rx History
                </Button>
                <Dropdown
                  isOpen={dropdownOpen}
                  toggle={() => setDropdownOpen(!dropdownOpen)}
                  style={{ marginLeft: "12px" }}
                >
                  <DropdownToggle color="primary" className="togglebtn">
                    {dropdownOpen ? (
                      <img src={closeIcon} alt="icon" />
                    ) : (
                      <img src={threeDotsIcon} alt="icon" />
                    )}
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem className="dropdownitem-border">
                      <img src={plusIcon} /> Add Notes
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Print
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> E-Rx Details{" "}
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Forward Rx
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Due
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> P/A
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Rx History
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Col>
            </Row>
          </div>
          <Row me="fixedHeight">
            <div className="initial-review-accordian-div">
              <Accordion open={openOne} toggle={togglebtnOne}>
                <AccordionItem>
                  <AccordionHeader targetId="1">
                    Order Details
                    <span className="order-details">
                      <img src={orderDetailsIcon} /> - $5.70
                    </span>
                  </AccordionHeader>
                  <AccordionBody accordionId="1">
                    <Row>
                      <Col>
                        <h2 className="heading-pres">New E-Prescription</h2>
                      </Col>
                      <Col>
                        <h2 className="heading-pres">Order Entry</h2>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={6}
                        sm={12}
                        style={{
                          backgroundColor: "#F7F7F7",
                          borderTop: "1px solid #d3d3d3",
                        }}
                      >
                        <Row
                          style={{
                            paddingTop: "12px",
                          }}
                        >
                          <Col lg={5} className="final-review-key">
                            Patient Name:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Doe, John
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Birth Date:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            01/08/1996
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Phone:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            (555) 978-6543
                          </Col>
                        </Row>
                        <div className="divider-pre"></div>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Prescriber Name:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Smith, Robert
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Office Address:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            1234 Maple Rd, Anytown, USA
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Office Phone:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            (555) 978-6543
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Date Written:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            12/19/2024
                          </Col>
                        </Row>
                        <div className="divider-pre"></div>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Medication:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Venlafaxine ER Tablet 150MG
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            DAW:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            0-Not Specified
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Quantity:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            30 EA
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Directions:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Take 1 Tablet by Mouth Daily
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Refills:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            5
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Electronic Signature:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Robert Smith. MD at 12/19/2024, 1:02 EST.
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Note:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Please contact the office to report any insurance
                            issues
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={12} md={6}>
                        <div
                          style={{
                            padding: "8px",
                            paddingTop: "0px",
                          }}
                        >
                          <Row
                            style={{
                              borderTop: "1px solid #D3D3D3",
                              paddingTop: "12px",
                            }}
                          >
                            <Col className="d-flex">
                              <div className="pdetails">Written Date:</div>
                              <div className="patient-details">12/19/2024</div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex">
                              <div className="pdetails">Dispense Date:</div>
                              <div className="patient-details">12/19/2024</div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex">
                              <div className="pdetails">Medication:</div>
                              <div className="patient-details">
                                Venlafaxine ER Tablet 150MG
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex">
                              <div className="pdetails">Prescriber Name:</div>
                              <div className="patient-details">
                                Smith, Robert
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex">
                              <div className="pdetails">Quantity:</div>
                              <div
                                className="patient-details"
                                style={{ fontWeight: 600 }}
                              >
                                30
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex">
                              <div className="pdetails">Refills:</div>
                              <div className="patient-details">5</div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex">
                              <div className="pdetails">Expiration Date:</div>
                              <div className="patient-details">12/01/2025</div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex">
                              <div className="pdetails">DAW:</div>
                              <div
                                className="patient-details"
                                style={{ fontWeight: 600 }}
                              >
                                0-Not Specified
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex">
                              <div className="pdetails">Payer 1#:</div>
                              <div className="patient-details">Express</div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex">
                              <div className="pdetails">Payer 2#:</div>
                              <div
                                className="patient-details"
                                style={{ fontWeight: 600 }}
                              >
                                Take 1 tablet by mouth Daily
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </AccordionBody>
                </AccordionItem>
              </Accordion>
              <Accordion open={false} toggle={togglebtnTwo} className="mb-2">
                <AccordionItem>
                  <AccordionHeader targetId="1">
                    Payment / Insurance Details
                  </AccordionHeader>
                  <AccordionBody accordionId="1" style={{ marginLeft: "16px" }}>
                    <Row>
                      <Col>
                        <div className="final-acc-header">
                          New E-Prescription
                        </div>
                      </Col>
                      <Col>
                        <div className="final-acc-header">Order Entry</div>
                      </Col>
                    </Row>
                  </AccordionBody>
                </AccordionItem>
              </Accordion>
              <Accordion open={false} toggle={togglebtnThree} className="mb-2">
                <AccordionItem>
                  <AccordionHeader targetId="1">Other Details</AccordionHeader>
                  <AccordionBody
                    accordionId="1"
                    style={{ marginLeft: "16px" }}
                  ></AccordionBody>
                </AccordionItem>
              </Accordion>
            </div>
          </Row>
        </Container>
        <Container
          fluid
          className="order-entry-acc-footer justify-content-between
    alignItems-center"
        >
          <div className="d-flex justify-content-start">
            <Button color="primary" className="reset">
              <img src={sendBackIcon} />
              Send Back
            </Button>
          </div>
          <div className="right-btn-div">
            <Button
              className="back-button"
              onClick={() => setPatientEditDetails(!patientEditDetails)}
            >
              <img src={editPurple} />
              Edit
            </Button>
            <Button color="primary" className="submit" onClick={onApprove}>
              <img src={appoveIcon} />
              Approve
            </Button>
          </div>
        </Container>
      </Container>
      <div>
        <Drawer
          direction="end"
          size="lg"
          isOpen={drugUtil}
          toggle={() => setDrugUtil(!drugUtil)}
          title="Drug Utilization Review"
        >
          <DrugUtilPopUp />
        </Drawer>
        <Drawer
          direction="end"
          size="lg"
          isOpen={claimsInfo}
          toggle={() => setClaimsInfo(!claimsInfo)}
          title="Claims Information"
        >
          <ClaimsInfo />
        </Drawer>
        <Drawer
          direction="end"
          size="lg"
          isOpen={msgInfo}
          toggle={() => setMsgInfo(!msgInfo)}
          title="Chat"
        >
          <Chating />
        </Drawer>
      </div>
      <Offcanvas
        style={{ width: "83vw" }}
        isOpen={patientEditDetails}
        toggle={() => setPatientEditDetails(!patientEditDetails)}
        direction="end"
      >
        <div className="casvas-header">
          <div>Edit Details (RX-1029484)</div>

          <div
            className="cursor-pointer"
            onClick={() => setPatientEditDetails(false)}
          >
            <img src={CloseIcon} />
          </div>
        </div>
        <div
          className="section-devider-border"
          style={{
            margin: "0px 12px 15px 18px",
          }}
        ></div>
        <OffcanvasBody>
          <InitialPatientEditDetails />
        </OffcanvasBody>
      </Offcanvas>
    </>
  );
};

export default InitialReviewPatientDetails;
